import type { ChangeEvent, FC } from 'react';
import { useCallback } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import SimpleBar from 'simplebar-react';
import * as Styled from './styled';
import type { AccordionProps, AccordionTab } from './types';

export * from './types';

export const Accordion: FC<AccordionProps> = (props) => {
  const {
    tabs,
    noScroll = false,
    wrapperClass,
    tabClass,
    labelClass,
    maxLabelWidth = false,
    ...rest
  } = props;

  const tabChangeHandler = useCallback(
    (tab: AccordionTab, event: ChangeEvent<HTMLInputElement>) => {
      tab.onChange?.(event);
      const tabElement = event.target.parentElement;
      if (!tabElement) return;
      const { checked } = event.target;
      tabElement.dataset.checked = checked ? 'true' : 'false';
      if (!checked) {
        tabElement.style.overflow = 'hidden';
      }
      setTimeout(() => {
        if (checked) {
          tabElement.style.overflow = 'visible';
        }
      }, 100);
    },
    [],
  );

  const prefix = (index: number) => `accordion-checkbox-${tabs[0]?.title}-${tabs.length}-${index}`;

  return (
    <Styled.Wrapper className={wrapperClass}>
      {tabs.map((tab, index) => (
        <Styled.Tab
          key={index}
          className={tabClass}
          {...((rest.defaultChecked || tab.defaultChecked) && {
            'data-checked': 'true',
            style: { overflow: 'visible' },
          })}
        >
          <Styled.Input
            {...rest}
            defaultChecked={rest.defaultChecked || tab.defaultChecked}
            type="checkbox"
            id={prefix(index)}
            onChange={(event) => tabChangeHandler(tab, event)}
            noScroll={noScroll}
          />
          <Styled.Label
            data-accordion-label
            htmlFor={prefix(index)}
            className={labelClass}
            {...tab.labelProps}
          >
            <Styled.IconTitleWrapper maxLabelWidth={maxLabelWidth}>
              {tab.icon}
              {tab.title}
            </Styled.IconTitleWrapper>
            {!!tab.content && <FaChevronRight data-accordion-icon />}
          </Styled.Label>
          <Styled.Content data-accordion-content>
            {noScroll ? (
              tab.content
            ) : (
              <SimpleBar style={{ maxHeight: 300 }}>{tab.content}</SimpleBar>
            )}
          </Styled.Content>
        </Styled.Tab>
      ))}
    </Styled.Wrapper>
  );
};
